export default {
  'riskControl':{
    'common':{
      'search': '搜索',
      'reset': '重置',
      'submit': '提交',
      'cancel': '取消',
      'confirm': '确认',
      'operation': '操作',
      'status': '状态',
      'createTime': '创建时间',
      'updateTime': '更新时间',
      'remark': '备注',
      'amount': '金额',
      'currency': '货币',
      'orderNumber': '订单号',
      'memberAccount': '会员账号',
      'fee': '手续费',
      'type': '类型',
      'all': '全部',
      'pending': '待处理',
      'processing': '处理中',
      'completed': '已完成',
      'failed': '失败',
      'rejected': '已拒绝',
      'approved': '已通过',
      'locked': '已锁定',
      'unlocked': '已解锁',
      'dateRange': '日期范围',
      'startDate': '开始日期',
      'endDate': '结束日期',
      'dateType': '日期类型',
      'dateType.createTime': '创建时间',
      'dateType.updateTime': '更新时间',
      'dateType.completeTime': '完成时间',
      'dateType.applyTime': '申请时间',
      'dateType.successTime': '完成时间',
      'noData': '暂无数据',
      'total': '共 {total} 条',
    },
    'withdrawal':{
      'title': '提款风控审核',
      'search':{
        'orderNo': '订单编号',
        'memberAccount': '会员账号',
        'currency': '提款币种',
        'orderStatus': '订单状态',
        'withdrawType': '提款类型',
        'dateType': '日期类型',
        'startTime': '开始时间',
        'endTime': '结束时间',
        'search': '搜索',
        'reset': '重置',
      },
      'table':{
        'orderNo': '订单编号',
        'memberAccount': '会员账号',
        'withdrawType': '提款类型',
        'withdrawInfo':'账户信息',
        'bankAccount':'银行账户名',
        'bankNumber':'银行卡号',
        'bankName':'银行名称',
        'usdtAccount':'USDT地址',
        'usdtType':'USDT链类型',
        'usdtRate':'USDT汇率',
        'walletRealName':'钱包真实姓名',
        'walletAccount':'钱包账号',
        'currency': '币种',
        'amount': '提款金额',
        'fee': '手续费',
        'realAmount': '实际金额',
        'orderStatus': '订单状态',
        'riskReason': '风控原因',
        'applyTime': '申请时间',
        'operation': '操作',
      },
      'riskReason':{
        'suspected': '疑似风控',
        'manualReview': '人工审核模式',
        'depositWithdrawDiffExceed': '存提差金额超标',
        'depositWithdrawPercentExceed': '存提百分比超标',
        'totalWinLossExceed': '累计输赢超标',
        'withdrawAmountExceed': '申请提款金额超标',
        'totalBonusExceed': '总优惠金额超标',
        'bonusDepositRatioExceed': '优惠存款比超标',
        'depositWithdrawBothExceed': '存提差、百分比同时超标',
        'bonusBothExceed': '总优惠、优惠存款比超标',
        'noDeposit':'0充值金额，白嫖党',
        'vipLevelMatch': 'VIP等级匹配风控规则 被风控',
        'gameArbitrageNoDeposit': '游戏套利风控 无存款用户风控规则 被风控',
        'gameArbitrageFirstDeposit': '游戏套利风控 首存用户风控规则 被风控',
        'gameArbitrageDeviceIp': '游戏套利风控 设备/IP风控规则 被风控',
      },
      'status':{
        'pending': '待审核',
        'processing': '待出款',
        'success': '已通过',
        'rejected': '已拒绝',
        'paying': '代付出款中',
        'locked': '出款锁定中',
        'riskLocked': '审核锁定中',
      },
      'message':{
        'fetchFailed': '获取数据失败',
        'updateSuccess': '更新成功',
        'updateFailed': '更新失败',
      },
      'button':{
        'approve': '通过',
        'reject': '拒绝',
        'lock': '锁定',
        'unlock': '解锁',
        'adminUnlock':'管理员解锁'
      },
      'confirm':{
        'title':'确认操作',
        'approve': '确认通过该笔提款申请？',
        'reject': '确认拒绝该笔提款申请？',
        'lock': '确认锁定该笔提款申请？',
        'unlock': '确认解锁该笔提款申请？',
      },
      'reject':{
        'reason': '拒绝原因',
        'reasonRequired': '请输入拒绝原因',
        'reasonPlaceholder': '请输入拒绝原因',
      },
      'lock':{
        'reason': '锁定原因',
        'reasonRequired': '请输入锁定原因',
        'reasonPlaceholder': '请输入锁定原因',
      },
      'unlock':{
        'reason': '解锁原因',
        'reasonRequired': '请输入解锁原因',
        'reasonPlaceholder': '请输入解锁原因',
      },
      'detail':{
        'title': '提款详情',
        'basicInfo': '基本信息',
        'riskInfo': '风控信息',
        'operationLog': '操作日志',
        'memberInfo': '会员信息',
        'accountInfo': '账户信息',
        'withdrawInfo': '提款信息',
        'riskLevel': '风控等级',
        'riskScore': '风控分数',
        'riskTags': '风控标签',
        'operationTime': '操作时间',
        'operator': '操作人',
        'operation': '操作',
        'remark': '备注',
      }
    },
    'blacklistQuery': {
      'title': '黑名单查询',
      'name': '姓名',
      'nameRequired': '请输入姓名',
      'namePlaceholder': '请输入姓名（支持截取查询）',
      'firstName': '名',
      'middleName': '中间名',
      'lastName': '姓',
      'birthdate': '出生日期',
      'source': '来源',
      'photo': '照片',
      'resultTitle': '查询结果',
      'queryFailedWithCode': '查询失败，状态码: {code}',
      'queryFailed': '查询失败',
      'unavailable': '不可用',
      'banned': '已封禁',
      'photoAlt': '照片'
    }
  }
}
